import Head from 'next/head';
import { jsx as _jsx } from "react/jsx-runtime";

const JsonSchemaRating = _ref => {
  let {
    name,
    description,
    ratingCount,
    ratingValue
  } = _ref;
  const result = {
    '@context': 'http://schema.org',
    '@type': 'SoftwareApplication',
    name,
    description,
    operatingSystem: 'All',
    applicationCategory: 'BrowserApplication',
    aggregateRating: {
      '@type': 'AggregateRating',
      ratingValue: `${ratingValue}`,
      ratingCount: `${ratingCount}`
    },
    offers: {
      '@type': 'Offer',
      price: '0',
      priceCurrency: 'USD'
    }
  };
  return /*#__PURE__*/_jsx(Head, {
    children: /*#__PURE__*/_jsx("script", {
      type: "application/ld+json" // @ts-ignore
      ,
      dangerouslySetInnerHTML: {
        __html: JSON.stringify(result)
      }
    })
  });
};

export default JsonSchemaRating;